exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".confetti-container {\n  flex: 1;\n  align-self: stretch;\n  display: flex;\n  position: relative;\n  overflow: hidden; }\n\n.confetti-container-top, .confetti-container-bottom {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 200px;\n  z-index: 2; }\n\n.children-container {\n  z-index: 3;\n  display: flex; }\n\n.confetti-container-top {\n  top: 0; }\n\n.confetti-container-bottom {\n  bottom: 0;\n  transform: rotate(180deg);\n  transform-origin: center; }\n\n.confetti {\n  position: absolute;\n  top: 0;\n  z-index: 10;\n  width: 16px;\n  height: 16px;\n  border-radius: 8px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Confetti.scss
// module id = 702
// module chunks = 0